import RandExp from 'randexp'

export const getSampleStringsFromRegex = (
  regexPattern: RegExp,
  attempts = 20,
  maxSamples = 3
): string[] => {
  const generator = new RandExp(regexPattern)
  const samples = [] as string[]

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < attempts && samples?.length <= maxSamples; i++) {
    const newSample = generator.gen()
    // adding only possible strings with different lenghts
    if (samples.every(existingSample => existingSample?.length !== newSample?.length)) {
      samples.push(newSample)
    }
  }
  return samples
}
